import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAdministradorPublicoRecursoConcedidoInicio: [],
    buscaAdministradorPublicoRecursoConcedidoSucesso: ['administradorPublicoRecursoConcedido'],
    buscaAdministradorPublicoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAdministradorPublicoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAdministradorPublicoRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarParecerAdministrador(filtro)
            .then(response => dispatch(Creators.buscaAdministradorPublicoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAdministradorPublicoRecursoConcedidoErro(error)))
    }
}

const buscaAdministradorPublicoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAdministradorPublicoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaAdministradorPublicoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.administradorPublicoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ADMINISTRADOR_PUBLICO_RECURSO_CONCEDIDO_INICIO]: buscaAdministradorPublicoRecursoConcedidoInicio,
    [Types.BUSCA_ADMINISTRADOR_PUBLICO_RECURSO_CONCEDIDO_ERRO]: buscaAdministradorPublicoRecursoConcedidoErro,
    [Types.BUSCA_ADMINISTRADOR_PUBLICO_RECURSO_CONCEDIDO_SUCESSO]: buscaAdministradorPublicoRecursoConcedidoSucesso,
})
